(() => {
  const ROOT_SELECTOR = '[data-embe-features]';

  function initSwipers(scope) {
    if (!window.Swiper) return false;

    let didAny = false;
    scope.querySelectorAll?.('[data-embe-features-swiper]')?.forEach?.((el) => {
      if (el._embeSwiper) return;

      const prev = el.querySelector('.swiper-button-prev');
      const next = el.querySelector('.swiper-button-next');
      const pagination = el.querySelector('.swiper-pagination');

      const opts = {
        slidesPerView: 1.2,
        spaceBetween: 10,
        speed: 500,
        roundLengths: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          640: { slidesPerView: 2 },
          1200: { slidesPerView: 3, spaceBetween: 16 },
          1600: { slidesPerView: 4, spaceBetween: 24 }
        }
      };

      // Only enable navigation when both buttons exist (Swiper may throw if passed null elements).
      if (prev && next) {
        opts.navigation = { prevEl: prev, nextEl: next };
      }

      if (pagination) {
        opts.pagination = { el: pagination, clickable: true };
      }

      el._embeSwiper = new window.Swiper(el, opts);
      didAny = true;
    });

    return didAny;
  }

  function setActiveTab(root, idx) {
    const tabs = root.querySelectorAll('[data-embe-features-tab]');
    const panels = root.querySelectorAll('[data-embe-features-panel]');
    const viewport = root.querySelector('[data-embe-features-panels]');
    const track = root.querySelector('[data-embe-features-panels-track]');
    tabs.forEach((t, i) => {
      const active = i === idx;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    if (viewport) viewport.style.setProperty('--embe-features-active-index', String(idx));

    panels.forEach((p, i) => {
      const active = i === idx;
      p.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    const panel = panels[idx];
    if (!panel) return;

    // Init Swiper only when panel is visible (avoids 0-width init).
    initSwipers(panel);

    const setPanelsHeight = () => {
      if (!viewport) return;
      const box = panel.querySelector('.embe-features__layout') || panel;
      const h = Math.ceil(box.getBoundingClientRect().height);
      if (h > 0) viewport.style.setProperty('--embe-features-panels-height', `${h}px`);
    };

    const sync = () => {
      panel.querySelectorAll?.('[data-embe-features-swiper]')?.forEach?.((el) => {
        const sw = el._embeSwiper;
        if (!sw) return;
        sw.updateSize?.();
        sw.updateSlides?.();
        sw.updateProgress?.();
        sw.updateSlidesClasses?.();
        sw.update?.();
      });
      setPanelsHeight();
    };

    // Update Swiper after the panels track finishes sliding (same fix as mega menu style)
    if (track) {
      const onEnd = (e) => {
        if (e.propertyName && e.propertyName !== 'transform') return;
        track.removeEventListener('transitionend', onEnd);
        sync();
      };
      track.addEventListener('transitionend', onEnd);
      setTimeout(sync, 450);
    } else {
      requestAnimationFrame(() => requestAnimationFrame(sync));
    }

    // Set immediately too (prevents initial blank space before first transition end)
    requestAnimationFrame(setPanelsHeight);

    // Keep height in sync as images load / layout shifts within the active panel.
    if (viewport) {
      root._embeFeaturesResizeObserver?.disconnect?.();
      const ro = new ResizeObserver(() => setPanelsHeight());
      ro.observe(panel.querySelector('.embe-features__layout') || panel);
      root._embeFeaturesResizeObserver = ro;

      panel.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', setPanelsHeight, { once: true });
        img.addEventListener('error', setPanelsHeight, { once: true });
      });
    }
  }

  function init(root = document) {
    root.querySelectorAll(ROOT_SELECTOR).forEach((features) => {
      if (features.dataset.embeInit === '1') return;
      features.dataset.embeInit = '1';

      const tabs = features.querySelectorAll('[data-embe-features-tab]');
      if (!tabs.length) return;

      setActiveTab(features, 0);

      tabs.forEach((btn) => {
        btn.addEventListener('click', () => setActiveTab(features, Number(btn.dataset.embeFeaturesIndex || 0)));
        btn.addEventListener('mouseenter', () => setActiveTab(features, Number(btn.dataset.embeFeaturesIndex || 0)));
        btn.addEventListener('focus', () => setActiveTab(features, Number(btn.dataset.embeFeaturesIndex || 0)));
      });

      // Swiper is loaded with defer; if this section initializes before Swiper is ready,
      // retry a few times so the slider doesn't stay uninitialized.
      if (!window.Swiper) {
        let tries = 0;
        const timer = setInterval(() => {
          tries += 1;
          if (window.Swiper) {
            setActiveTab(features, 0);
            clearInterval(timer);
            return;
          }
          if (tries >= 20) clearInterval(timer);
        }, 100);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

